import { hasTouch, isHP } from 'app/device';
import Routes from 'app/routes';
import { Games } from 'services';

// MAIN
const CHARTS = {
    name: 'charts',
    route: Routes.GAMES.CHARTS,
};

const HIGHLIGHTS = {
    name: 'highlights',
    route: Routes.GAMES.HIGHLIGHTS,
};

const SUBSCRIBE = {
    name: 'subscribe',
    route: Routes.SUBSCRIBE,
    titleKey: 'navigation.upgrade',
};

const TOUCH = {
    name: 'touch',
    route: `${Routes.GAMES.CATEGORY}/touch`,
    isCategory: true,
    titleKey: 'categories.touch',
};

const CATEGORIES_BASE = {
    name: 'categories',
    route: Routes.GAMES.CATEGORIES,
};

// ASIDE
const SEARCH = {
    name: 'search',
    route: Routes.GAMES.SEARCH,
};

const FAVORITES = {
    name: 'favorites',
    route: Routes.GAMES.FAVORITES,
};

const SETTINGS = {
    name: 'settings',
    route: '',
};

// BASE_NAVIGATON
export const BASE_NAVIGATION = {
    main: [CHARTS],
    aside: [SETTINGS],
};

export const getNavigation = () => {
    // Deep clone using JSON method, don't spread... ! we should include DeepClone from loadash in the future for more flexibility.
    // see differences between JSON method and DeepClone from loadash : https://www.samanthaming.com/tidbits/70-3-ways-to-clone-objects/#shallow-clone-vs-deep-clone
    let navigation = JSON.parse(JSON.stringify(BASE_NAVIGATION));

    // categories may change depending on user profile
    const CATEGORIES = {
        ...CATEGORIES_BASE,
        subMenu: ['all', ...Games.GetFilteredCategories().map((c) => c.name)],
    };

    /**
     * DISCOVERY NAVIGATION
     */
    if (Games.isDiscoveryOffer()) {
        if (process.env.NODE_ENV === 'development')
            console.log('NAVIGATION --> DISCOVERY');

        // in discovery mode, the highlights page is shown with a different name
        const _HIGHLIGHTS = {
            ...HIGHLIGHTS,
            titleKey: 'navigation.games',
        };

        // add highlights
        navigation.main.splice(0, 0, _HIGHLIGHTS);

        // add touch device category
        if (hasTouch() && Games.GetCategoryGames('touch')?.length > 0) {
            if (process.env.NODE_ENV === 'development')
                console.log('NAVIGATION --> DISCOVERY AND TOUCH');

            navigation.main.push(TOUCH);
        }

        // add subscribe/offers
        if (Games.GetSubscribableOffers().length > 0) {
            navigation.main.push(SUBSCRIBE);
        }
    } else if (isHP) {
        /**
         * HP NAVIGATION
         */
        if (process.env.NODE_ENV === 'development')
            console.log('NAVIGATION --> HOPSITLATY');

        // add categories first place of main menu
        navigation.main.splice(0, 0, CATEGORIES);

        // add search to main nav
        navigation.main.push(SEARCH);
    } else {
        /**
         * REGULAR NAVIGATION
         */
        if (process.env.NODE_ENV === 'development')
            console.log('NAVIGATION --> DEFAULT');

        // add highlights
        navigation.main.splice(0, 0, HIGHLIGHTS);

        // add categorires
        navigation.main.push(CATEGORIES);

        // add search - 1st
        navigation.aside.splice(0, 0, SEARCH);

        // add favorites  - 2nd
        // TODO: Games.FavoritesEnabled()
        navigation.aside.splice(1, 0, FAVORITES);

        // touch device navigation
        if (hasTouch() && Games.GetCategoryGames('touch').length > 0) {
            if (process.env.NODE_ENV === 'development')
                console.log('NAVIGATION --> NORMAL AND TOUCH');

            navigation.main.push(TOUCH);
        }
    }

    return navigation;
};
